/**
 * Created by alex.shmaltsuev on 2016-06-14.
 */

export default {
    GET_SSP_INTL: 'GET_SSP_INTL',
    INTL:'Intl',
    INTL_OBJECT:'intlObject'
}


// WEBPACK FOOTER //
// ./constants/intl.js